import React from 'react';
import Card from 'react-bootstrap/Card';
import { ImPointRight } from 'react-icons/im';
function AboutCard() {
  return (
    <Card className='quote-card-view'>
      <Card.Body>
        <blockquote className='blockquote mb-0'>
          <p style={{ textAlign: 'justify' }}>
            Hi Everyone, I am <span className='purple'>Jobin Johnson </span>
            from <span className='purple'> India.</span>
            <br />
            Results-driven Computer Science student at Karunya Institute of
            Technology and Sciences passionate about developing user-friendly
            software applications.
            <br />
            Good problem-solving skills and ability to perform well in a team.
            Seeking to grow and develop skills as a coder.
            <br />
            <br />
            <span className='purple'>Areas of expertise:</span> Problem-solving,
            Leadership, Communication, Time management.
          </p>
          <ul>
            <li className='about-activity'>
              <ImPointRight /> Playing Games
            </li>
            <li className='about-activity'>
              <ImPointRight /> Music
            </li>
            <li className='about-activity'>
              <ImPointRight /> Travelling
            </li>
            <li className='about-activity'>
              <ImPointRight /> Watching Movies
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
